import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** SALE（S即興・Aアクティブ・L冒険グルメ・E体験） */
const saleContent: DiagnosisResultContent = {
  code: 'SALE',
  name: '爆速即興トラベラー',
  catchphrase: 'ノープランでも全力疾走、その場のノリで攻める冒険家',
  rarity: 5,
  style:
    '「考えるより動く」を地で行く即興派の行動者。計画はほぼ立てず、現地の空気と勘で次々に動く。冒険的なグルメも未知の体験も飛び込みで楽しみ、フットワークの軽さは随一。失敗すらネタにする瞬発力で、誰も予想しない旅をつくる。自由と刺激を何より愛する、旅のエンターテイナータイプ。',
  strengths: [
    { lead: '瞬発力が圧倒的', text: 'その場の好機を逃さず、偶然の名シーンを引き寄せる。' },
    { lead: '変化に強い', text: '予定が崩れても動じず、むしろ流れを楽しめる。' },
    { lead: '体験の幅が広い', text: '飛び込みで未知の食や場所に挑み、旅の密度が高い。' },
  ],
  weaknesses: [
    { lead: '計画性に欠ける', text: '予約や下調べ不足で、機会損失やトラブルが起きやすい。' },
    { lead: '同行者が振り回されがち', text: 'ペースが速く読めず、合わせる側が疲れることがある。' },
    { lead: '行き当たりばったりの代償', text: '人気店・人気宿は満席で入れないことが多い。' },
  ],
  aaru: [
    { icon: 'msg', text: '「とりあえず行ってみよう」が口癖' },
    { icon: 'utensils', text: '看板に惹かれて即入店' },
    { icon: 'camera', text: '予定外の絶景に出会いがち' },
    { icon: 'coffee', text: '帰りの便ギリギリまで遊ぶ' },
  ],
  manual: {
    good: 'ノリに乗る／突発の提案を面白がる',
    ng: '「ちゃんと計画して」と縛る',
    tips: '最終便と宿だけは押さえておくと事故が減る',
  },
  compatibility: {
    good: 'SALZ（即興仲間）／SRLE（冒険食）',
    conflict: 'PACZ（安心計画）／PRCZ（快適派）',
    tips: '帰りの時間だけ共有すれば自由に動ける',
  },
  destinations: {
    domestic: '大阪（ノリで攻める食い倒れ）／福岡（屋台と即興グルメ）',
    overseas: 'バンコク（飛び込み天国）／台北（夜まで動ける街）',
  },
};

export const saleDiagnosisResult = buildDiagnosisResult(saleContent);
